import styled from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'

const StNotes = styled(Span)`
  ul {
    list-style-type: disc;
  }

  li {
    margin-left: ${({ theme }) => theme.UI.SpacingPx.Space3};
  }

  a {
    color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
  }
`

export { StNotes }
